import { useEffect, useState } from "react";
import styles from "./list.module.css";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Snackbar, Alert, Checkbox } from "@mui/material";
import { StyledMainTableCell } from "../../../components/TableComponent";
import TablePaginationComponent from "../../../components/TablePagination";
import { Close } from "@mui/icons-material";
import { Calendar, Home, Search } from "react-feather";
import axios from "axios";
import Loader from "../../../components/Loader";
import { TableLoader } from "../../../components/ContentLoader";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import TableCustomRow from "./TableCustomRow";
import { DateRangePicker } from "rsuite";
import dayjs from "dayjs";

const PickedUpItems = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", status: "", date: null });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [selected, setSelected] = useState([]);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchBookings = () => {
      setContentLoading(true);

      axios.get(process.env.REACT_APP_API_URL + "v1/picked-item", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchBookings();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item.booking_id.toLowerCase().includes(inputVal) || item.customer_name.toLowerCase().includes(inputVal) || item.post_code.toLowerCase().includes(inputVal) || item.created_user.toLowerCase().includes(inputVal));
      });
    }

    if (filterVars?.date) {
      filterredTempData = filterredTempData.filter((i) => dayjs(i?.pickup_date).isBetween(dayjs(filterVars?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const makeReceivedAll = (item) => {
    let itemIds = item?.products?.map((sub) => {
      if (sub.is_wh_received === 0) {
        return sub.id;
      }
      return null;
    });
    itemIds = itemIds.filter((i) => i !== null);

    setLoading(true);

    let postData = { bookingPIds: itemIds };
    axios.post(process.env.REACT_APP_API_URL + "v1/make-as-received", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios(process.env.REACT_APP_API_URL + "v1/picked-item", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            let allData = response.data.data;
            setLoading(false);
            setSnackbarType("success");
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setAllData(allData);
          } else {
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  };

  const makeReceived = (item) => {
    setLoading(true);

    let postData = { bookingPIds: [item?.id] };

    axios.post(process.env.REACT_APP_API_URL + "v1/make-as-received", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response1) => {
      if (response1.data.status === "SUCCESS") {
        axios(process.env.REACT_APP_API_URL + "v1/picked-item", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          },
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            let allData = response.data.data;
            setLoading(false);
            setSnackbarType("success");
            setSnackbarOpen(true);
            setSnackbarMessage(response1.data.message);
            setAllData(allData);
          } else {
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const selectRowEvent = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  }

  const reciveByBookIds = () => {
    if (selected.length === 0) {
      setSnackbarType("error");
      setSnackbarOpen(true);
      setSnackbarMessage("Please select booking");

      return false;
    }
    setLoading(true);

    let postData = { bookingIds: selected };
    axios.post(process.env.REACT_APP_API_URL + "v1/make-as-received-by-book-id", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios(process.env.REACT_APP_API_URL + "v1/picked-item", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            let allData = response.data.data;
            setLoading(false);
            setSnackbarType("success");
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setAllData(allData);
          } else {
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>View Picked Items</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Booking</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>Picked Items</li>
            </ol>
          </nav>
        </div>)}

        {contentLoading && <TableLoader />}

        {!contentLoading && (<>
          <div className="TableFilterHead">
            <div className="DataTableSearch WithFilter">
              <Search className="SearchIcon" />
              <TextField type="text" placeholder="Search" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
            <div className="TableFilterBUSec">
              <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                <div className={`${styles.DashFilterSec} DashFilterSec`}>
                  <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" caretAs={Calendar} showOneCalendar value={filterVars?.date} onChange={(e) => setFilterVars((prev) => { return { ...prev, date: e }; })} />
                </div>
              </div>

              <div className={`${styles.FilterCard} Filter`}>
                <div className={`${styles.DashFilterSec} DashFilterSec`}>
                  <div className={`${styles.FilerButton}`}>
                    <Button className="TableAddBUName" onClick={(e) => reciveByBookIds()}>Receive All</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="CusTable">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell padding="checkbox">
                      <Checkbox
                        className="AllCheckbox"
                        color="primary"
                        indeterminate={selected?.length > 0 && selected?.length < filteredData?.length}
                        checked={filteredData?.length > 0 && selected?.length === filteredData?.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newSelected = filteredData.map((n) => n.id);
                            setSelected(newSelected);
                            return;
                          }
                          setSelected([]);
                        }}
                      />
                    </StyledMainTableCell>
                    <StyledMainTableCell>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell>Customer Name</StyledMainTableCell>
                    <StyledMainTableCell>Pickup Address</StyledMainTableCell>
                    <StyledMainTableCell>Pickup Date</StyledMainTableCell>
                    <StyledMainTableCell></StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => {
                    const isItemSelected = selected.indexOf(item?.id) !== -1;
                    return <TableCustomRow item={item} isItemSelected={isItemSelected} makeReceivedAll={makeReceivedAll.bind(this)} makeReceived={makeReceived.bind(this)} selectRowEvent={selectRowEvent.bind(this)} />;
                  })}

                  {filteredData.length === 0 && (<TableRow>
                    <TableCell colSpan={10} align="center">No data found</TableCell>
                  </TableRow>)}
                </TableBody>

                {filteredData?.length > 0 && (<TableFooter>
                  <TableRow>
                    <TablePaginationComponent
                      count={filteredData?.length}
                      colSpan={6}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={
                        paginationChangeRowsPerPage
                      }
                    />
                  </TableRow>
                </TableFooter>)}
              </Table>
            </TableContainer>
          </div>
        </>)}
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>
  );
};

export default withAdminAuth(PickedUpItems);